import React, { useEffect, useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import PlanImg from './../../../../assets/images/weerp/web-image/super-admin/plans.png';
import SubscriptionImg from './../../../../assets/images/weerp/web-image/super-admin/subscriptons.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function PlanSubscription({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
 /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const panelName   = projectType.panelName;
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(2004);
        document.title = 'Plan & Subscriptions | ' + projectName + ' web';
        setDefaultWebActiveMenu(4);
    }, [projectName]);

    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">{panelName}</li>
                        <li className="breadcrumb-item active" aria-current="page">Plan & Subscriptions</li>
                    </ol>
                </nav>
                <div id="dashboards" ref={sectionRefs['4']}>
                    <h4 className="font-weight-bold mt-5  ">Plan & Subscriptions</h4>
                    <h5 className="border-top font-weight-bold mt-5 pt-2 text-primary"># Plans</h5>
                    <p className="pt-3">Plan wise Modules can be assigned. And the price of the plan can be given. A default plan can be added.</p>

                    <div className='pt-3'>
                        <img src={PlanImg} className="w-100 rounded" alt="Plans"></img>
                    </div>
                    <h5 className="border-top font-weight-bold mt-5 pt-2 text-primary"># Subscription</h5>
                    <p className='mt-4'>All subscription list here. Admin can change business plan from admin panel.</p>
                    <div className='pt-3'>
                        <img src={SubscriptionImg} className="w-100 rounded" alt="Subscription"></img>
                    </div>

                 

                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/admin/business`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Business</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/admin/settings`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Settings</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
